async function getNextSet(
  reader: FileSystemDirectoryReader,
): Promise<FileSystemEntry[]> {
  return new Promise((resolve) => {
    reader.readEntries((results: FileSystemEntry[]) => {
      resolve(results)
    })
  })
}

export async function filesForFolder(
  folder: FileSystemDirectoryEntry,
): Promise<FileSystemEntry[]> {
  if (!folder?.isDirectory) {
    return Promise.reject(new Error('not a directory'))
  }
  const reader = folder.createReader()
  const allEntries: FileSystemEntry[] = []
  let hasMore = true
  while (hasMore) {
    const nextSet = await getNextSet(reader)
    hasMore = nextSet.length === 100
    allEntries.push(...nextSet)
  }
  return allEntries
}

export type IFolders = {
  [name: string]: IFolderContent
}

export interface IFolderContent {
  files: File[]
  folders: IFolders
}

export async function filesThatMeetCondition(
  folder: FileSystemDirectoryEntry,
  condition: (file: FileSystemDirectoryEntry) => boolean,
): Promise<FileSystemDirectoryEntry[]> {
  const files: FileSystemDirectoryEntry[] = []
  if (!folder.isDirectory) {
    if (condition(folder)) {
      files.push(folder)
    }
    return files
  }
  const subFiles = await filesForFolder(folder)
  const promises = subFiles.map(async (file) => {
    const result = await filesThatMeetCondition(
      file as FileSystemDirectoryEntry,
      condition,
    )
    files.push(...result)
  })
  await Promise.all(promises)
  return files
}

export async function notFolders(folder: FileSystemDirectoryEntry) {
  return filesThatMeetCondition(
    folder,
    (file: FileSystemDirectoryEntry) => !file.name.startsWith('.'),
  )
}

export function removeEmptyHtmlStuff(htmlString: string) {
  return htmlString.replace(/\n/g, '').replace(/>[\t ]+</g, '><')
}

export function parseHtmlString(htmlString: string, keepWhiteSpace?: boolean) {
  const parser = new DOMParser()
  const doc = parser.parseFromString(htmlString, 'text/html')
  // remove the white space and new lines between tags
  if (!keepWhiteSpace) {
    doc.body.innerHTML = removeEmptyHtmlStuff(doc.body.innerHTML)
  }
  return doc
}

export function fileFromJson(json: object, name: string): File {
  const blob = new Blob([JSON.stringify(json, null, 2)], { type: 'text/plain' })
  return new File([blob], `${name}.json`)
}
